import { render, staticRenderFns } from "./HeaderRoute.vue?vue&type=template&id=fb5a28e6&scoped=true"
import script from "./HeaderRoute.vue?vue&type=script&lang=js"
export * from "./HeaderRoute.vue?vue&type=script&lang=js"
import style0 from "./HeaderRoute.vue?vue&type=style&index=0&id=fb5a28e6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb5a28e6",
  null
  
)

export default component.exports